import React from 'react'
import Paper from '@mui/material/Paper'

import { TextBlock } from '../../../../components/1elements'

const RectangleEdit = ({ shape, setShape }) => {
  const changeRelay = e => {
    if (!e.target.value && e.target.name !== 'name') {
      e.defaultPrevented = true
      e.isDefaultPrevented = true
      return
    }
    const nameParts = e.target.name.split('.')
    if (nameParts.length > 1) {
      const containerName = nameParts[0]
      const container = shape[containerName]
      container[nameParts[1]] = e.target.value
      setShape({ id: shape.id, [containerName]: container })
    } else {
      const needRedraw = e.target.name !== 'name'
      setShape({ id: shape.id, [e.target.name]: e.target.value }, needRedraw)
    }
  }

  return (
    <Paper>
      <TextBlock heading={shape.name + ':'}>
        <div> Name:</div>
        <input
          type='text'
          name='name'
          value={shape.name}
          onChange={changeRelay}
          required
          maxLength={150}
          style={{ width: '100%' }}
        />

        <div>North:</div>
        <input
          type='number'
          name='bounds.north'
          value={shape.bounds.north}
          width={'100%'}
          onChange={changeRelay}
          max={90}
          min={-90}
          required
          style={{ width: '100%' }}
          step={0.01}
        />
        <div>South:</div>
        <input
          type='number'
          name='bounds.south'
          value={shape.bounds.south}
          onChange={changeRelay}
          max={90}
          min={-90}
          required
          style={{ width: '100%' }}
          step={0.01}
        />
        <div>East:</div>
        <input
          type='number'
          name='bounds.east'
          value={shape.bounds.east}
          onChange={changeRelay}
          max={180}
          min={-180}
          required
          style={{ width: '100%' }}
          step={0.01}
        />
        <div>West:</div>
        <input
          type='number'
          name='bounds.west'
          value={shape.bounds.west}
          onChange={changeRelay}
          max={180}
          min={-180}
          required
          style={{ width: '100%' }}
          step={0.01}
        />
      </TextBlock>
    </Paper>
  )
}

export default React.memo(RectangleEdit)
